import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Deliberately no throw on a dead session: callers omit the Authorization
// header and the backend 401s, instead of every request failing client-side
// (RTK Query console.errors those, flooding Datadog). undefined is
// definitive — Amplify rethrows transient network/service errors and only
// reports "no tokens" for real auth failures (TokenOrchestrator.handleErrors
// in @aws-amplify/auth). fetchAuthSession would also hit the identity pool.
export const getAccessToken = async (): Promise<string | undefined> => {
  const tokens = await cognitoUserPoolsTokenProvider.getTokens();
  return tokens?.accessToken.toString();
};
